import { t } from "@lingui/macro";
import * as React from "react";
import { G, Path, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const PersonAddIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Person Add`} {...props}>
    <G
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      clipPath="url(#a)"
      fill="none"
    >
      <Path d="M1 13.5v-1.667c0-.884.369-1.732 1.025-2.357A3.59 3.59 0 0 1 4.5 8.5H8M15 12H9M12 9v6M7.5 6a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h16v16H0z" />
      </ClipPath>
    </Defs>
  </Icon>
);
